import LocalizedStrings from 'localized-strings';

interface InternationalTransferDynamicFormFieldLocale {
  maxLength: string;
  minLength: string;
  patternNotMatching: string;
  required: string;
}

export default new LocalizedStrings<InternationalTransferDynamicFormFieldLocale>(
  {
    en: {
      maxLength: 'Max. {0} characters',
      minLength: 'Min. {0} characters',
      patternNotMatching: 'Does not seem to be valid',
      required: 'Required',
    },
    fr: {
      maxLength: 'Max. {0} caractères',
      minLength: 'Min. {0} caractères',
      patternNotMatching: 'Ne semble pas valide',
      required: 'Requis',
    },
  } as const,
);
